import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=6037fb06&scoped=true&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=ts&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./LoadingIndicator.vue?vue&type=style&index=0&id=6037fb06&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6037fb06",
  null
  ,true
)

component.options.__file = "LoadingIndicator.vue"
export default component.exports